import React from 'react';
import { Typography, Space } from 'antd';
import {
  ShoppingOutlined,
  CarOutlined,
  UserOutlined,
  CoffeeOutlined,
  SoundOutlined,
  StarOutlined,
  ScissorOutlined,
  EyeOutlined,
  HomeOutlined,
  GlobalOutlined,
  DollarOutlined,
  HeartOutlined,
  GiftOutlined,
  ShopOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

// Icon size constant
const ICON_SIZE = '16px';

// Category dictionary with code, name, and icon
// Icons are chosen to match iOS-style profession icons
export const categoryDictionary = {
      charity: {
        name: 'Charity',
        nameCompany: 'Charity',
        icon: <HeartOutlined style={{ fontSize: ICON_SIZE }} />,
      },
      delivery: {
        name: 'Food Delivery',
        nameCompany: 'Food Delivery',
        icon: <GiftOutlined style={{ fontSize: ICON_SIZE }} />, // Takeout bag representation
      },
      courier: {
        name: 'Courier',
        nameCompany: 'Couriers',
        icon: <CarOutlined style={{ fontSize: ICON_SIZE }} />, // Bicycle/courier representation
      },
      waiter: {
        name: 'Waiter/Server',
        nameCompany: 'Restaurants',
        icon: <UserOutlined style={{ fontSize: ICON_SIZE }} />, // Person with arm raised
      },
      barista: {
        name: 'Barista',
        nameCompany: 'Coffeshops',
        icon: <CoffeeOutlined style={{ fontSize: ICON_SIZE }} />,
      },
      bartender: {
        name: 'Bartender',
        nameCompany: 'Bars',
        icon: <ShopOutlined style={{ fontSize: ICON_SIZE }} />, // Bar/drinks representation
      },
      busker: {
        name: 'Busker',
        nameCompany: 'Music',
        icon: <SoundOutlined style={{ fontSize: ICON_SIZE }} />, // Music/guitar representation
      },
      hair: {
        name: 'Hairdresser/Stylist',
        nameCompany: 'Hair and Beauty',
        icon: <StarOutlined style={{ fontSize: ICON_SIZE }} />, // Hand with stars
      },
      nails: {
        name: 'Nail technician',
        nameCompany: 'Nails',
        icon: <ScissorOutlined style={{ fontSize: ICON_SIZE }} />, // Hand/nail representation
      },
      beauty: {
        name: 'Therapist',
        nameCompany: 'Therapy',
        icon: <EyeOutlined style={{ fontSize: ICON_SIZE }} />, // Eye with eyelashes
      },
      barber: {
        name: 'Barber',
        nameCompany: 'Barbers',
        icon: <ScissorOutlined style={{ fontSize: ICON_SIZE, color: '#ff69b4' }} />, // Pink scissors like iOS
      },
      hotel: {
        name: 'Hotel staff',
        nameCompany: 'Hotel',
        icon: <HomeOutlined style={{ fontSize: ICON_SIZE }} />, // Building representation
      },
      porter: {
        name: 'Porter',
        nameCompany: 'Hotel Operations',
        icon: <ShoppingOutlined style={{ fontSize: ICON_SIZE }} />, // Suitcase representation
      },
      taxi: {
        name: 'Taxi',
        nameCompany: 'Taxis',
        icon: <CarOutlined style={{ fontSize: ICON_SIZE }} />, // Car/taxi representation
      },
      tour: {
        name: 'Tour Manager',
        nameCompany: 'Tour Operator',
        icon: <GlobalOutlined style={{ fontSize: ICON_SIZE }} />, // Map representation
      },
      other: {
        name: 'Other',
        nameCompany: 'Other Business',
        icon: <DollarOutlined style={{ fontSize: ICON_SIZE }} />,
      },
};

/**
 * Component to display client category with icon
 * @param {string} categoryCode - The category code (e.g., 'bartender', 'barista')
 * @param {boolean} isCompany - Whether this is a company account
 * @param {object} style - Optional style object
 */
export const ClientCategoryDisplay = ({ categoryCode, isCompany, style }) => {
  const code = categoryCode || 'other';
  const category = categoryDictionary[code] || categoryDictionary.other;
  const displayName = isCompany ? category.nameCompany : category.name;

  return (
    <Space style={style}>
      {category.icon}
      <Text>{displayName}</Text>
    </Space>
  );
};

export default ClientCategoryDisplay;

